import React from 'react';
import { HeroSection } from './components/HeroSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PainPointsSection } from './components/PainPointsSection';
import { SystemOverview } from './components/SystemOverview';
import { TomosSlider } from './components/TomosSlider';
import { BonusesSlider } from './components/BonusesSlider';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingSection } from './components/PricingSection';
import { ProAvanzadoSection } from './components/ProAvanzadoSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { ComparisonSection } from './components/ComparisonSection';
import { FooterSection } from './components/FooterSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-neutral-950 font-sans selection:bg-amber-500/30" data-id="element-0">
      <HeroSection data-id="element-1" />
      <TestimonialsSection data-id="element-2" />
      <PainPointsSection data-id="element-3" />
      <SystemOverview data-id="element-4" />
      <TomosSlider data-id="element-5" />
      <BonusesSlider data-id="element-6" />
      <CountdownTimer data-id="element-7" />
      <PricingSection data-id="element-8" />
      <ProAvanzadoSection data-id="element-9" />
      <ExtendedTestimonials data-id="element-10" />
      <GuaranteeSection data-id="element-11" />
      <FAQSection data-id="element-12" />
      <ComparisonSection data-id="element-13" />

      {/* Final CTA Section */}
      <div className="bg-neutral-950 pt-16" data-id="element-14">
        <div className="text-center mb-8 px-4" data-id="element-15">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4" data-id="element-16">
            No dejes pasar esta oportunidad
          </h2>
        </div>
        <CountdownTimer data-id="element-17" />
        <PricingSection data-id="element-18" />
      </div>

      <FooterSection data-id="element-19" />
      <SocialProofPopup data-id="element-20" />
    </div>;
}